module.exports = __webpack_public_path__ + "img/logo.0761d6e9.svg";